import React from 'react';
import { Box } from '@mui/material';
import SanityImage from 'gatsby-plugin-sanity-image';
import { flip, get } from 'lodash';

interface BasicImageProps {
  value: {
    alignSelf?: 'flex-start' | 'center' | 'flex-end' | undefined;
    image: any;
    name: string;
    width?: string[];
    loadingMethod?: 'lazy' | 'eager' | undefined;
  };
}



const BasicImage = ({ value }: BasicImageProps) => {

  const getWidth = () => {
    if (value.width) return value.width;
    return value?.image?.asset?.width ?? '100%';
  };

  return (
    <>
      <Box
        
        /**********************************************************************
         * * ALIGNMENT IN PORTABLE TEXT
         * ---------------------------------------------------------------------
         * FURTURE SELF:
         * Most content on the site is rendered using portable text. This means
         * that the content is dynamic and can be placed anywhere on the page.
         * Howver, portable text doesn't allow you to highlight objects such
         * as an image and center it. So, you need to enable the ability to
         * center the image by adding alignment props to the actual image object
         * or component.
         * 
         * In this case, the image position setting is added to the CMS. When
         * an image is added, the user can select the position of the image. That
         * is then passed to this component as a value that can be used to set
         * the alignment of the image.
         * 
         * The parent component is a flex container. This means that the image
         * can be aligned using the 'alignSelf' property.
         * *********************************************************************/
        alignSelf={value.alignSelf ?? 'flex-start'}        

        position={'relative'}
        component={SanityImage}
        alt={'Image'}
        {...value.image}
        width={getWidth()}
        maxWidth={'100%'}
        height="auto"
        sx={{
          objectFit: 'contain',
          aspectRatio: `auto ${value.image.asset.width} / ${value.image.asset.height}`,          
        }}
        loading={value.loadingMethod ?? 'lazy'}              
      />
    </>
  );
};

export default BasicImage;
